import * as React from 'react';

import ClassificationBadge16 from './ClassificationBadge16';

export const classificationBadge16 = () => <ClassificationBadge16 />;

export default {
    title: 'Icon/Line/ClassificationBadge16',
    component: ClassificationBadge16,
    parameters: {
        notes: "`import ClassificationBadge16 from 'box-ui-elements/es/icon/line/ClassificationBadge16';`",
    },
};
